import parsePhoneNumber from "libphonenumber-js/max";

export function add_query(url, key, value) {
  let alreadyRegexp = new RegExp(`(${key}=[^&]+)`);
  let match = alreadyRegexp.exec(url);
  if (match) {
    return url.replace(match[1], `${key}=${value}`);
  } else {
    if (/\?/.test(url)) {
      return (url += `&${key}=${value}`);
    } else {
      return (url += `?${key}=${value}`);
    }
  }
}

export function generateUUID() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

export function renumberInputs(selector, field) {
  $(selector).each(function (i) {
    let $e = $(this);
    $e.find("[id]").each(function () {
      let $e2 = $(this);
      $e2.attr("id", $e2.attr("id").replace(new RegExp(`${field}_\\d+_`, "g"), `${field}_${i}_`));
    });
    $e.find("[name]").each(function () {
      let $e2 = $(this);
      $e2.attr("name", $e2.attr("name").replace(new RegExp(`${field}\\]\\[\\d+\\]`, "g"), `${field}][${i}]`));
    });
  });
}

export function ppNumber(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(",");
}

export function s3Url(filepath) {
  const random_query = "?date=" + new Date().valueOf();
  return window._s3_root + filepath + random_query;
}

// Function to help validate a mobile phone number (Useful pour electronic signature)
// The function assume that a span help-block exists
// For now we can only assume it is a French mobile number (May, 2022) to keep consistency on every phone number fields.
export function validateMobilePhoneNumber(target) {
  let help_block = target.closest("div:not(.text-input)").querySelector(".js-help-phone-number");
  if (help_block) {
    if (target.value != "") {
      const phone_number = parsePhoneNumber(target.value, "FR");
      if (phone_number && phone_number.getType() == "MOBILE") {
        if (help_block) {
          help_block.style.display = "none";
        }
      } else {
        help_block.style.display = "";
      }
    } else {
      help_block.style.display = "none";
    }
  }
}

// Function to deal with unsafe HTML in the front end - using it is most likely a code smell,
// but in any case, it is better than leaving an XSS
export function escapeHTML(unsafe) {
  const map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;",
  };

  return unsafe.replace(/[&<>"']/g, function (m) {
    return map[m];
  });
}

export function getEl(elOrSelector) {
  if (typeof elOrSelector === "string") {
    elOrSelector = document.querySelector(elOrSelector);
  }
  if (!elOrSelector) {
    throw new Error("No element provided, double check the selector.");
  }
  return elOrSelector;
}

// The following is a bit hard to follow but interacting with
// <template> elements is... interesting.
export function instanciateTemplate(elOrSelector, target, onCloned) {
  const el = getEl(elOrSelector);
  const instance = el.content.cloneNode(true).firstElementChild;
  if (onCloned) {
    onCloned(instance, el);
  }
  return target.appendChild(instance);
}
